import React from 'react'
import useFeatureFlags from 'hooks/useFeatureFlags'
import { WrappedFamilySettings } from './index'

type WrappedFamilySettingsProps = { useNewLayout?: boolean }

const FamilySettingsScreenWrapper = () => {
  const flags = useFeatureFlags({
    flagNames: ['new_family_portal_settings']
  })?.data

  const useNewLayout =
    flags?.new_family_portal_settings?.enabled ?? false

  const TypedWrappedFamilySettings =
    WrappedFamilySettings as React.ComponentType<WrappedFamilySettingsProps>

  return <TypedWrappedFamilySettings useNewLayout={useNewLayout} />
}

export default FamilySettingsScreenWrapper
